import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
    name: 'arraySearch'
})
@Injectable()
export class arraySearch implements PipeTransform {
    transform(items: any[], field: string, searchVal: string): any[] {
        if (!items) {
            return [];
        }
        if (!searchVal) {
            return items;
        }
        else {
            return items.filter(singledata => singledata[field].toUpperCase().includes(searchVal.toUpperCase()));
        }
    }
}